
import { Component, Vue } from 'vue-property-decorator';
import { DataService } from '@/service/DataService';
import { RoomSpace, Room as iRoom, User } from '@/utils/models';
import Room from '@/components/room/Room.vue';
import { Route } from 'vue-router';
Component.registerHooks(['beforeRouteEnter', 'beforeRouteUpdate']);
@Component({ components: { Room } })
export default class RoomView extends Vue {
  dataService: DataService | null = null;

  selectedSpace: RoomSpace | null = null;
  selectedRoom: iRoom | null = null;
  get user(): User {
    return this.$store.state.user;
  }
  beforeRouteEnter(to: Route, from: Route, next: any) {
    console.log('view beforeRouteEnter', to);
    next((vm: RoomView) => vm.initialize(to));
  }
  initialize(route?: Route) {
    this.dataService = this.$store.state.dataService;
    if (route?.path === '/chat') {
      const spaceName = (this.$route.query.space as string) || '';
      const roomName = (this.$route.query.room as string) || '';
      this.dataService!.emitGetRoomState(spaceName, roomName).then((space?: RoomSpace) => {
        let room = space?.rooms.find((r) => r.name === roomName);
        if (space && room) {
          this.$router.replace(`/room/${space.id}/${room?.id}`);
        } else {
          // not found
          console.log('not found room');
          this.$toast.error('ルームが見つかりませんでした。');
          this.$router.push('/');
        }
      });
    } else if (!route) {
      const spaceid = this.$route.params.spaceid || '';
      const roomid = this.$route.params.roomid || '';
      this.dataService!.emitGetRoomStateById(spaceid, roomid).then((space?: RoomSpace) => {
        let room = space?.rooms.find((r) => r.id === roomid);
        if (space && room) {
          this.selectedSpace = space;
          this.selectedRoom = room;
        } else {
          // not found
          console.log('not found room');
          this.$toast.error('ルームが見つかりませんでした。');
          this.$router.push('/');
        }
      });
    }
  }
  mounted() {
    this.initialize();
    this.dataService!.onRoomUpdated((res) => {
      if (res.isNeedReload) {
        this.$toast.warning('ルーム情報が更新されました。リロードしてください。', {
          onClick: () => location.reload(),
          onClose: () => location.reload(),
          timeout: false,
        });
      } else if (res.room.id === this.selectedRoom?.id) {
        this.selectedRoom = res.room;
      }
    });
  }
  beforeDestroy(): void {
    this.dataService!.removeAllListeners();
    console.log('room view destroyed');
  }
  onWheel(ev: WheelEvent) {
    if (ev.ctrlKey) {
      ev.preventDefault();
    }
  }
}
